import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const compareToValidationRuleResolvers: Record<'>' | '>=' | '<' | '<=', BaseValidationRuleResolver<number>> = {
  '>': (value, rule) => {
    return typeof value === 'number' && value > rule.value ? null : `Must be greater than ${rule.value}`;
  },
  '>=': (value, rule) => {
    return typeof value === 'number' && value >= rule.value ? null : `Must be greater than or equal to ${rule.value}`;
  },
  '<': (value, rule) => {
    return typeof value === 'number' && value < rule.value ? null : `Must be less than ${rule.value}`;
  },
  '<=': (value, rule) => {
    return typeof value === 'number' && value <= rule.value ? null : `Must be less than or equal to ${rule.value}`;
  },
};
